var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShiny(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5653_9740)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.44821 12.6236C9.48009 12.6236 11.8356 15.9694 11.8356 18.1459C11.8356 18.2358 11.9076 18.3078 11.9975 18.3078C12.0874 18.3078 12.1593 18.2358 12.1593 18.1459C12.1593 15.9694 14.5149 12.6236 16.5467 12.6236C16.6366 12.6236 16.7086 12.5517 16.7086 12.4617C16.7086 12.3718 16.6366 12.2999 16.5467 12.2999C14.5149 12.2999 12.1593 8.95413 12.1593 6.77761C12.1593 6.68767 12.0874 6.61572 11.9975 6.61572C11.9076 6.61572 11.8356 6.68767 11.8356 6.77761C11.8356 8.95233 9.48009 12.2999 7.44821 12.2999C7.3583 12.2999 7.28638 12.3718 7.28638 12.4617C7.28638 12.5517 7.3583 12.6236 7.44821 12.6236Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6946 7.49702C15.288 7.49702 15.9892 8.48635 15.9892 9.13391C15.9892 9.15189 16.0072 9.18787 16.0432 9.18787C16.0611 9.18787 16.0971 9.16988 16.0971 9.13391C16.0971 8.48635 16.7984 7.49702 17.3918 7.49702C17.4097 7.49702 17.4457 7.47903 17.4457 7.44306C17.4457 7.42507 17.4277 7.38909 17.3918 7.38909C16.7984 7.38909 16.0971 6.39977 16.0971 5.75221C16.0971 5.73422 16.0791 5.69824 16.0432 5.69824C16.0252 5.69824 15.9892 5.71623 15.9892 5.75221C15.9892 6.39977 15.288 7.38909 14.6946 7.38909C14.6766 7.38909 14.6406 7.40708 14.6406 7.44306C14.6406 7.46104 14.6586 7.49702 14.6946 7.49702Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5653_9740"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.1594,
    height: 12.6112,
    fill: "white",
    transform: "translate(7.28638 5.69824)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShiny);
export default __webpack_public_path__ + "static/media/shiny.c219607c3517aef777edc0c84cd7ef73.svg";
export { ForwardRef as ReactComponent };